import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, IndexRoute, browserHistory } from 'react-router'
import ReactGA from 'react-ga';
// import App from './App';
import Layout from './components/Layout';
import DetectLang from './components/DetectLang';
import InterfaceLang from './components/InterfaceLang';
import Translator from './components/Translator';
import NotFound from './components/NotFound';

// styles
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import './styles/index.css';
import './styles/navbar.css';
import './styles/footer.css';

ReactGA.initialize('UA-4706454-6');

function logPageView() {
    ReactGA.set({ page: window.location.pathname });
    ReactGA.pageview(window.location.pathname);
}

ReactDOM.render(
    <Router history={browserHistory} onUpdate={logPageView}>
        <Route path="/" component={Layout}>
            <IndexRoute component={DetectLang} />
            <Route path='404' component={NotFound} />
            <Route path=":interfaceLang" component={InterfaceLang}>
                {/* sub-routes could be added and cleaned up */}
                <Route path=":srcLang(/:tgtLang)(/:term)" component={Translator} />
            </Route>
        </Route>
    </Router>,
    document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/